module.exports = __webpack_public_path__ + "img/pin-filled.07abac33.svg";